import React from 'react';
import { COLORS, FONTS } from '@bcm/constants';
import { View, StyleSheet, Image } from 'react-native';
import { useSelector } from 'react-redux';

const Partners = () => {

	const isLandscape = useSelector( state => state.globals.isLandscape);

	const styles = StyleSheet.create({
		container: {
			height: isLandscape ? 100 : undefined,
			width: '100%',
			padding: !isLandscape ? 10 :'15vw',
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: COLORS.white,
		},
		row: {
			flexDirection: isLandscape ? 'row' : 'column',
		},
		text: {
			fontFamily: FONTS.default,
			fontSize: isLandscape ? 40 : 30,
			marginVertical: 10,
			textAlign: 'center',
		},
		partnersImageContainer: {
			height: 110,
			width: 220,
			marginHorizontal: 30,
			marginVertical: 10,
		},
	});

	return (
		<View style={styles.container}>
			<View style={styles.row}>
				<Image
					source={require('../../assets/images/partners/elevanceLogo.png')}
					style={styles.partnersImageContainer}
					resizeMode={'contain'}
				/>
				<Image
					source={require('../../assets/images/partners/iCorpLogo.jpg')}
					style={styles.partnersImageContainer}
					resizeMode={'contain'}
				/>
				<Image
					source={require('../../assets/images/partners/northeasternLogo.png')}
					style={styles.partnersImageContainer}
					resizeMode={'contain'}
				/>
			</View>
		</View>
	);
};

export default Partners;